





import { Component, Prop, Vue } from 'vue-property-decorator';
import MoreBadge from '@/components/parts/slider/badges/Badges.vue';
import Common from '../common';
import MoreTitle from '../components/Title.vue';
import MoreNote from '../components/Note.vue';
import MorePrice from '../components/Price.vue';
import MoreButton from '../components/More.vue';
import Locked from '../components/Locked.vue';

@Component
export default class ComponentPartCatalogListTitle extends Vue
{
  @Prop({ type: Boolean, default: true })
  constrained: boolean;

  get classes() {
    return { title__constrained: this.constrained };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/list/item/components/Title.vue